import { Box, Button, Dialog, DialogActions, DialogContent, Divider, FormControl, FormHelperText, Grid, IconButton, InputAdornment, makeStyles, Modal, styled, TextField, Theme, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { BlackExitIcon, CheckedRadio, PdfIcon, UncheckRadio } from '../../../assets/SvgIcons'
import { CustomeButton, CustomeModalDropDown } from '../../../lib/formik/NewFormInputs'
import { useFormik } from 'formik'
import * as Yup from 'yup';
import { GetMandateCreationDetailsResponseBody, GetMandateRegisteredResponseBody, MandateCreation } from '../../../redux-store/types/investorProfile'
import { useDispatch, useSelector } from 'react-redux'
import { getMandateCreationDetails, getMandateRegistered, } from '../../../redux-store/actions/investorProfile'
import { useHistory } from 'react-router'
import { fontSize } from '@mui/system'
import { RootStateType } from '../../../redux-store/reducers'
import { NEXEDGE_MDMS_APIS, USER_ROLES } from '../../../utils/constant'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import CalendarIcon from '../../../assets/icons/CalendarIcon'
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { addYearsAndSubtractOneDay, isRMLikeRole } from '../../../utils/utilityFunctions'
import { showError } from '../../../redux-store/actions/auth'

type Props = {
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    setActiveTab?: React.Dispatch<React.SetStateAction<string>>
    title: string
    handleClose: (str: string) => void
    bankMandateDetails?: Array<MandateCreation>
    clientCode?: string
    mandateRequestDialog?: boolean,
    setMandateRequestDialog?: React.Dispatch<React.SetStateAction<boolean>>,
    mandateFormValues?: Partial<Values>,
    setMandateFormValues?: React.Dispatch<React.SetStateAction<Values>>,
    selectedRadio?: number,
    setSelectedRadio?: React.Dispatch<React.SetStateAction<number>>,
    radioList?: { id: number, label: string }[];
    handleSuccess?: () => void
}

interface Values {
    amount: string;
    accountNo: string;
    ifscCode: string;
    bankName: string;
    startDate?: string;
    endDate?: string;
    acctType?: string;
    // months: string;
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '950px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    borderRadius: '12px',
    // p: '24px',
    ':focus': {
        outline: 'none'
    },
}

// const radioList = [
//     {
//         id: 1,
//         label: 'XSIP',
//     },
//     {
//         id: 2,
//         label: 'E-Mandate',
//     }
// ]



const BankValidation = Yup.object().shape({
    amount: Yup.string().required('Amount is required')
        .test('not-zero', 'Amount cannot be zero', (value) => {
            if (!value) return false;
            // Remove commas, trim, and check if numeric and not all zeros
            const numeric = parseFloat(value.replace(/,/g, '').trim());
            return numeric > 0;
        }),
    accountNo: Yup.string().required('Required'),
    ifscCode: Yup.string().required('Required').transform((value) => {
        return value && value.toUpperCase()
    }),
    bankName: Yup.string().nullable().required('Bank name is required').matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field "),
    startDate: Yup.string().nullable()
        .required('Start date is required')
        .test("checkDate", function (value, context) {
            const { path, createError } = context;
            const date = new Date(value ?? "");
            const todaysDate = new Date();
            date.setHours(0, 0, 0, 0);
            todaysDate.setHours(0, 0, 0, 0);

            if (isNaN(date.getTime())) {
                return createError({
                    message: 'Invalid Start Date',
                    path
                })
            }
            if (date < todaysDate) {
                return createError({
                    message: 'Start date should be greater than or equal to today',
                    path
                })
            }

            return true;
        }),
    endDate: Yup.string().nullable()
        .required('End date is required')
        .test("checkDate", function (value, context) {
            const { path, parent, createError } = context;
            const date = new Date(value ?? "");
            const startDate = new Date(parent?.startDate);
            date.setHours(0, 0, 0, 0);
            startDate.setHours(0, 0, 0, 0);

            const fortyYrsFromNow = dayjs(startDate).add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD")
            if (isNaN(date.getTime())) {
                return createError({
                    message: 'Invalid End Date',
                    path
                })
            }
            if (dayjs(date).format("YYYY-MM-DD") < (dayjs(startDate).format("YYYY-MM-DD"))) {
                return createError({
                    message: 'End date should be greater than or equal to start date',
                    path
                })
            }
            if (dayjs(date).format("YYYY-MM-DD") > fortyYrsFromNow) {
                return createError({
                    message: 'End date should not exceed maximum of 479 months from start date',
                    path
                })
            }
            return true
        })
    // months: Yup.string()
    //     .required('Months field is required')
    //     .test("checkMonths", "Months should be from 6 to 480", function (value) {
    //         if (value) {
    //             return parseInt(value) >= 6 && parseInt(value) <= 480;
    //         }
    //         return true
    //     })
})


const initialData = {
    amount: '99999',
    accountNo: '',
    ifscCode: '',
    bankName: '',
    startDate: dayjs().format("YYYY-MM-DD"),
    endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
    acctType: '',
    // months: '',
}


const radioList = [
    {
        id: 0,
        label: 'E-Mandate',
    },
    // {
    //     id: 1,
    //     label: 'XSIP',
    // }
]

const AddBankModal = (props: Props) => {
    const { open, setOpen, title, setActiveTab, handleClose, clientCode, mandateRequestDialog, setMandateRequestDialog, mandateFormValues, handleSuccess } = props
    const theme = useTheme();
    const { palette } = useTheme()
    const dispatch = useDispatch()
    const { location: { pathname } } = useHistory()


    const [bankMandateDetails, setBankMandateDetailsRes] = useState<Array<MandateCreation>>([]);
    const [bankAccountNumbers, setBankNumber] = useState<Array<{ label: string, value: string }>>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [dialogPopup, setDialogPopup] = useState<boolean>(false);
    const [registerMandateRes, setRegisterMandateRes] = useState({} as GetMandateRegisteredResponseBody);
    const [selectedRadio, setSelectedRadio] = useState<number>(radioList[0]?.id);
    const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const { clientInterfaceCode } = useSelector((state: RootStateType) => state.id)
    const { role = '' } = useSelector((state: RootStateType) => state.auth);

    const { handleChange, values, handleSubmit, handleBlur, setFieldValue, errors, validateOnChange, validateField, setValues } = useFormik({
        initialValues: initialData,
        onSubmit: handleFormSubmit,
        validationSchema: BankValidation,
        validateOnBlur: false,
        validateOnChange: false,
        enableReinitialize: true
    })


    const fortyYrsFromNow = dayjs(values?.startDate).add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD")


    useEffect(() => {

        const fetchApi = async () => {

            try {
                setLoading(true);

                const res = await (dispatch(getMandateCreationDetails({ clientCode: clientCode, portfolioId: selectedPortfolio?.value })) as unknown as Promise<Array<MandateCreation>>);

                const bankMandateDetailsRes: GetMandateCreationDetailsResponseBody = {
                    "mandateCreationDetails": res
                }
                // console.log("BANK DETAILS RES", bankMandateDetailsRes);
                setBankMandateDetailsRes(bankMandateDetailsRes?.mandateCreationDetails);
                setFieldValue('ifscCode', bankMandateDetailsRes?.mandateCreationDetails[0]?.ifscCode)
                setFieldValue('bankName', bankMandateDetailsRes?.mandateCreationDetails[0]?.bankName)
                setFieldValue('accountNo', bankMandateDetailsRes?.mandateCreationDetails[0]?.bankAccountNumber)
                setFieldValue('acctType', bankMandateDetailsRes?.mandateCreationDetails[0]?.bankAccountType || '');

                setBankNumber(() => {
                    return bankMandateDetailsRes?.mandateCreationDetails?.map((item) => {
                        return {
                            label: item?.bankAccountNumber,
                            value: item?.bankAccountNumber
                        }
                    })
                })

                setFieldValue('startDate', values?.startDate);
                setFieldValue('endDate', values?.endDate);

            } catch (e) {
                console.log("Error", e);
            } finally {
                setLoading(false);
            }
        }
        fetchApi();
    }, [])

    const handleModalDropdown = (name: string, value: string) => {
        // console.log("Value", value);
        setFieldValue("accountNo", value.toString());
        const filteredAccountNumbers = bankMandateDetails?.filter((account) => parseInt(account.bankAccountNumber) === parseInt(value));

        setFieldValue('bankName', filteredAccountNumbers?.[0]?.bankName)
        setFieldValue('ifscCode', filteredAccountNumbers?.[0]?.ifscCode)
        setFieldValue('acctType', filteredAccountNumbers?.[0]?.bankAccountType);

    };


    async function handleFormSubmit(value: Values) {
        if (dayjs(value.endDate).isBefore(dayjs(value.startDate))) {
            dispatch(showError('End date should be greater than or equal to start date'));
            return;
        }
        else if (dayjs(value.endDate).isAfter(fortyYrsFromNow)) {
            dispatch(showError('End Date exceeds maximum duration of 379 months'));
            return;
        }

        const registerMandatePayload = {
            amount: value?.amount?.toString(),
            actype: value?.acctType ?? "",
            mandateType: selectedRadio === 1 ? "X" : "N",
            clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
            ifscCode: value?.ifscCode,
            accountNo: value?.accountNo,
            // months: parseInt(value?.months),
            bankName: value?.bankName,
            portfolioId: selectedPortfolio?.value,
            startDate: dayjs(value?.startDate).format("MM/DD/YYYY"),
            endDate: dayjs(value?.endDate).format("MM/DD/YYYY"),
        }

        try {
            setLoading(true);
            const res = await (dispatch(getMandateRegistered(registerMandatePayload)) as unknown as Promise<GetMandateRegisteredResponseBody>);
            setRegisterMandateRes(res);
            if (res?.is_mandate_registered) {
                setDialogPopup(true);
            }
        } catch (e) {
            console.log("E", e);
        } finally {
            setLoading(false);
        }
    }

    // useEffect(() => {
    //     if (bankMandateDetails) {
    //         setFieldValue('ifscCode', bankMandateDetails[0]?.ifscCode)
    //         setFieldValue('bankName', bankMandateDetails[0]?.bankName)
    //         setFieldValue('accountNo', bankMandateDetails[0]?.bankAccountNumber)

    //     }
    // }, [bankMandateDetails])

    // const handleOnChange = (name: string, value: string | number) => {
    //     if (name === 'startDate') {
    //         setValues({
    //             ...values,
    //             startDate: dayjs(value).format("YYYY-MM-DD"),
    //             endDate: dayjs(value).add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
    //         })
    //     }
    //     else{
    //         setFieldValue(name, value);
    //     }
    //     setTimeout(() => {
    //         validateField(name)
    //     }, 500);
    // }
    const handleOnChange = (name: string, value: string | number) => {
        if (name === 'startDate') {
            const newStartDate = dayjs(value).format("YYYY-MM-DD");
            const newEndDate = dayjs(value).add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD");

            setValues((prev) => ({
                ...prev,
                startDate: newStartDate,
                endDate: newEndDate,
            }));

            // Validate both startDate and endDate after update
            setTimeout(() => {
                validateField('startDate');
                validateField('endDate');
            }, 0);
        } else {
            setFieldValue(name, value);
            setTimeout(() => {
                validateField(name);
            }, 0);
        }
    };


    return (
        <>
            <Modal
                open={open}
                onClose={() => handleClose('close')}
                aria-labelledby="add-bank-modal-title"
                aria-describedby="form-modal"
            >
                <Box sx={{ ...style }}>
                    <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} flexDirection={'row'} borderBottom={`1px solid ${palette.text.secondary}B2`} padding={{ lg: '25px 30px', md: '25px 30px', sm: '15px 25px', xs: '15px 25px' }}>
                        <Typography id="add-bank-modal-title" variant="h2" fontSize={{ lg: '20px', md: '20px', sm: '16px', xs: '16px' }}>
                            {title}
                        </Typography>
                        <IconButton aria-label="Close dialog" onClick={() => handleClose('close')}>
                            <BlackExitIcon />
                        </IconButton>
                    </Box>
                    <Box padding={'35px 30px 25px'} component={'div'} id="form-modal" sx={{
                        overflowY: 'scroll',
                        maxHeight: { sm: '80vh', xs: '80vh' },
                    }}>
                        <Box display={'flex'} flexDirection={'row'} gap={'10px'}>
                            {radioList?.map((item) => (
                                <Box key={item.id} component={'button'} display={'flex'} alignItems={'center'} gap={'10px'} borderRadius={'10px'} border={`1px solid ${palette.text.secondary}80`} padding={'10px 15px'} width={'fit-content'}
                                    sx={{ background: item.id === selectedRadio ? palette.primary[500] + '1A' : 'transparent', cursor: 'pointer' }}
                                    onClick={() => setSelectedRadio && setSelectedRadio(item.id)}>
                                    {item.id === selectedRadio ? <CheckedRadio /> : <UncheckRadio />}
                                    <Typography variant="body_500" fontSize={{ lg: '16px', md: '16px', sm: '14px', xs: '14px' }} color={item.id === selectedRadio ? palette.primary[500] : palette.text.secondary}>{item.label}</Typography>
                                </Box>
                            ))}
                        </Box>
                        <Box sx={{ margin: '15px 0', borderTop: '.5px solid #CDCDCD', borderBottom: '.5px solid #CDCDCD' }}>

                            <Grid container columnSpacing={4} rowSpacing={'45px'} padding={'45px 0'}>
                                <Grid item lg={6} md={12} sm={12} xs={12}>
                                    <CustomeTextField label="Mandate Limit" symbol={true} type={'number'} name={'amount'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange('amount', e.target.value)} value={values.amount} handleBlur={handleBlur} error={errors.amount} onKeyDown={(e) => {
                                        if (['-', '+', 'e', 'E'].includes(e.key)) {
                                            e.preventDefault();
                                        }
                                    }} />
                                </Grid>
                                <Grid item lg={6} md={12} sm={12} xs={12}>
                                    <CustomeModalDropDown name='accountNo' label="Bank Account Number" onChange={handleModalDropdown} data={bankAccountNumbers || []} value={values.accountNo} loading={loading} />
                                </Grid>
                                <Grid item lg={6} md={12} sm={12} xs={12}>
                                    <CustomeTextField label="IFSC Code" type={'text'} name={'ifsc'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange('ifsc', e.target.value)} value={values.ifscCode} handleBlur={handleBlur} error={errors.ifscCode} disabled={true} />
                                </Grid>
                                <Grid item lg={6} md={12} sm={12} xs={12}>
                                    <CustomeTextField label="Bank Name" type={'text'} name={'bankName'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange('bankName', e.target.value)} value={values.bankName} handleBlur={handleBlur} error={errors.bankName} disabled={true} />
                                </Grid>

                                {/* Date Additions */}
                                {/* Start Date */}
                                <Grid item lg={6} md={12} sm={12} xs={12}>
                                    <CustomStartDateField value={values.startDate} handleOnChange={handleOnChange} error={errors.startDate} />
                                </Grid>

                                {/* End Date */}

                                <Grid item lg={6} md={12} sm={12} xs={12}>
                                    <CustomEndDateField value={values.endDate} startDate={values.startDate} handleOnChange={handleOnChange} error={errors.endDate} />
                                </Grid>
                            </Grid>


                        </Box>
                        <Box marginTop={'25px'} gap={'25px'} display={'flex'} flexDirection={'column'}>
                            <Box>
                                <Typography variant='subtitle_400' color={palette.text.secondary} fontSize={{ lg: '16px', md: '16px', sm: '14px', xs: '14px' }}>
                                    <Typography variant='body_500' fontWeight={600} color={palette.primary[500]} component={'span'}>Note: </Typography>
                                    {selectedRadio === radioList?.[0].id ? `This is a Digital Mandate requiring the investor to use Netbanking Facility. They'll receive a link for a 1 Rupee payment from their bank account. Verification takes 2 working days. List of Allowed Banks is below.` : 'This is a Physical Mandate that requires printing, signing, and scanning. Verification with the bank usually takes 21 working days.'}
                                </Typography>
                            </Box>
                            {selectedRadio === radioList?.[0].id && (
                                <Box display={'flex'} gap={'10px'} alignItems={'center'}>
                                    <PdfIcon />
                                    <Typography
                                        variant='overline_600'
                                        color={palette.primary[500]}
                                        sx={{
                                            textTransform: 'capitalize',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => window.open((
                                            NEXEDGE_MDMS_APIS ?
                                                "https://thrivewmsuat.kfintech.com/api/mdms/list_of_allowed_banks.pdf"
                                                : "http://wmsdev.kfintech.com/mdms/list_of_allowed_banks.pdf"), '_blank'
                                        )}
                                    >
                                        LIST OF ALLOWED BANKS
                                    </Typography>

                                </Box>
                            )}
                            <Box>
                                <CustomeButton lookType={'contained'} btnText={'Submit'} isLoading={loading} onClick={handleSubmit} />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal >
            <Dialog
                open={dialogPopup}
                maxWidth='sm'
                fullWidth
                sx={{
                    '& .MuiPaper-root': {
                        borderRadius: '15px',
                        backgroundColor: "background.paper",
                    },
                }}
            >
                <DialogContent sx={{ paddingTop: "24px" }}>
                    <Box sx={{ display: "flex", columnGap: "8px" }}>
                        <Typography variant='h2' color="text.primary" mb="10px">{'Mandate Request Sent'}</Typography>
                    </Box>

                    <Typography
                        component={'span'}
                        variant='subtitle_400'
                        color="text.secondary"
                        sx={{
                            lineHeight: "20px"
                        }}
                    >
                        {radioList?.[0].id === selectedRadio && isRMLikeRole(role) ? 'Email sent to investor to authenticate.' : ''}
                    </Typography>
                </DialogContent>

                {/* <DialogContent>
                    <Typography
                        component={'span'}
                        variant='body_500'
                        sx={(theme: Theme) => ({
                            lineHeight: "20px",
                            color: theme.palette.primary[500]
                        })}
                    >
                        {'Note:'}
                    </Typography>
                    <Typography
                        component={'span'}
                        variant='subtitle_400'
                        sx={(theme: Theme) => ({
                            lineHeight: "20px",
                            color: theme.palette.text.secondary,
                            fontSize: { lg: '16px', md: '16px', sm: '14px', xs: '14px' },
                        })}
                    >
                        {radioList?.[0].id === selectedRadio ? 'Until then, you can process with the Lumpsum investment.' : 'This is a Physical Mandate requiring the investor to print, sign, and upload the scanned version. Verification takes 21 working days with the bank.'}
                    </Typography>

                </DialogContent> */}

                <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
                    <Button
                        variant="contained"
                        sx={(theme: Theme) => ({
                            flex: 1,
                            color: theme.palette.textDark.primary,
                            padding: "10px",
                            fontSize: { lg: '14px', md: '14px', sm: '12px', xs: '12px' },
                        })}
                        onClick={() => {
                            if (selectedRadio === radioList?.[0]?.id && role === USER_ROLES.INVESTOR) {
                                handleClose(registerMandateRes?.emandateUrl ?? '');
                            }
                            else {
                                handleClose('close');
                            }
                            handleSuccess && handleSuccess()
                            setDialogPopup(false)
                        }}
                    >
                        {(selectedRadio === radioList[0]?.id && role === USER_ROLES.INVESTOR && registerMandateRes?.emandateUrl !== "") ? "Complete ELOG" : 'OK'}
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    )
}

export default AddBankModal


type CustomeTextFieldProps = {
    label: string,
    min?: number,
    minlabel?: string,
    max?: number
    maxlabel?: string
    symbol?: boolean
    type: string
    name: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    value: string
    handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    error?: string
    disabled?: boolean,
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
}


const CssTextField = styled(TextField)(({ theme, error }) => ({
    // height: '50px',
    '& label.Mui-focused': {
        color: `${error ? theme.palette.error.main : theme.palette.text.secondary}`,
        fontSize: { lg: '16px', md: '16px', sm: '14px', xs: '14px' },
    },
    '& label.Mui-disabled': {
        color: `${theme.palette.text.secondary}`,
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: `${error ? theme.palette.error.main : theme.palette.text.secondary}80`,
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: `${error ? theme.palette.error.main : theme.palette.text.secondary}80`,
            fontSize: { lg: '16px', md: '16px', sm: '14px', xs: '14px' },
        },
        '&:hover fieldset': {
            borderColor: `${error ? theme.palette.error.main : theme.palette.text.secondary}80`,
        },
        '&.Mui-focused fieldset': {
            borderColor: `${error ? theme.palette.error.main : theme.palette.primary.main}`,
        },
        '& .MuiTypography-body1': {
            color: `${theme.palette.text.primary}`,
        },
        color: `${theme.palette.text.primary}`,
        fontWeight: 500,
    },
}));

const CustomeTextField = (props: CustomeTextFieldProps) => {
    const { label, min, minlabel, max, maxlabel, symbol, type, name, onChange, value, handleBlur, error, disabled, onKeyDown } = props
    const { palette } = useTheme()
    const { currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);


    return (
        <Box>
            <CssTextField
                type={type}
                name={name}
                error={typeof error === 'string'}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e)}
                onBlur={(e: React.FocusEvent<HTMLInputElement>) => handleBlur && handleBlur(e)}
                onWheel={event => event.target instanceof HTMLElement && event.target.blur()}
                onPaste={e => e.preventDefault()}
                value={value}
                color='primary'
                defaultValue={' '}
                size='small'
                id="outlined-basic"
                label={label}
                variant="outlined"
                disabled={disabled}
                fullWidth
                InputProps={{
                    sx: {
                        borderRadius: '10px',
                        fontSize: { lg: '16px', md: '16px', sm: '14px', xs: '14px' },
                    },
                    startAdornment: symbol ? <InputAdornment position="start">{String.fromCharCode(parseInt(currencySymbol, 16))}</InputAdornment> : null
                }}
                onKeyDown={onKeyDown}
            />
            {typeof error === 'string' && error !== 'Required' && (
                <Box display={'flex'} flexDirection={'row'} gap={'20px'}>
                    <Typography variant="subtitle_500" fontSize={{ lg: '14px', md: '14px', sm: '12px', xs: '12px' }} color={palette.error[500]}>{error}</Typography>
                </Box>
            )}
            {min && max && (
                <Box display={'flex'} flexDirection={'row'} gap={'20px'}>
                    <Typography variant="subtitle_500" fontSize={{ lg: '14px', md: '14px', sm: '12px', xs: '12px' }} color={palette.text.primary}>Min: {minlabel}</Typography>
                    <Typography variant="subtitle_500" fontSize={{ lg: '14px', md: '14px', sm: '12px', xs: '12px' }} color={palette.text.primary}>Max: {maxlabel}</Typography>
                </Box>
            )}
        </Box>
    )
}

const CustomStartDateField = (props: any) => {
    const { value, handleOnChange, error } = props
    const theme = useTheme()
    const { currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);


    return (
        <Box>
            <FormControl fullWidth sx={{ my: { xs: 1, sm: 1, md: 1.5 } }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label={"Start Date"}
                        value={dayjs(value)}
                        onChange={(date: any) => {
                            handleOnChange('startDate', date?.format("YYYY-MM-DD") ?? dayjs(new Date()).format("YYYY-MM-DD"));
                        }
                        }
                        slots={{
                            openPickerIcon: () => <CalendarIcon fillColor={theme.palette.primary[500]} />,
                        }}
                        format="DD/MM/YYYY"
                        views={['year', 'month', 'day']}
                        minDate={dayjs(new Date())}
                        sx={{
                            '&.MuiTextField-root': {
                                '& fieldset': {
                                    borderRadius: "10px",
                                    backgroundColor: `${theme.palette.common.white}0D`,
                                    border: `0.5px solid ${theme.palette.text.secondary}80`,
                                },
                                '.MuiInputBase-input': {
                                    ...theme.typography.body_500,
                                    letterSpacing: "0.32px",
                                    color: theme.palette.text.primary,
                                    padding: "10px"
                                },
                            },
                        }}
                    />
                </LocalizationProvider>
            </FormControl>
            {typeof error === 'string' && error !== 'Required' && (
                <Box display={'flex'} flexDirection={'row'} gap={'20px'}>
                    <Typography variant="subtitle_500" fontSize={{ lg: '14px', md: '14px', sm: '12px', xs: '12px' }} color={theme.palette.error[500]}>{error}</Typography>
                </Box>
            )}
            {/* {min && max && (
                <Box display={'flex'} flexDirection={'row'} gap={'20px'}>
                    <Typography variant="subtitle_500" fontSize={{ lg: '14px', md: '14px', sm: '12px', xs: '12px' }} color={palette.text.primary}>Min: {minlabel}</Typography>
                    <Typography variant="subtitle_500" fontSize={{ lg: '14px', md: '14px', sm: '12px', xs: '12px' }} color={palette.text.primary}>Max: {maxlabel}</Typography>
                </Box>
            )} */}
        </Box>
    )
}

const CustomEndDateField = (props: any) => {
    const { startDate, handleOnChange, error, value } = props
    const theme = useTheme()
    const fortyYrsFromNow = dayjs(startDate).add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD");

    return (
        <Box>
            <FormControl fullWidth sx={{ my: { xs: 1, sm: 1, md: 1.5 } }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="End Date"
                        value={dayjs(value)}
                        onChange={(date: any) => {
                            handleOnChange('endDate', date?.format("YYYY-MM-DD") ?? dayjs(new Date()).format("YYYY-MM-DD"));
                        }
                        }
                        slots={{
                            openPickerIcon: () => <CalendarIcon fillColor={theme.palette.primary[500]} />,
                        }}
                        maxDate={dayjs(fortyYrsFromNow)}
                        format="DD/MM/YYYY"
                        views={['year', 'month', 'day']}
                        sx={{
                            '&.MuiTextField-root': {
                                '& fieldset': {
                                    borderRadius: "10px",
                                    backgroundColor: `${theme.palette.common.white}0D`,
                                    border: `0.5px solid ${theme.palette.text.secondary}80`,
                                },
                                '.MuiInputBase-input': {
                                    ...theme.typography.body_500,
                                    letterSpacing: "0.32px",
                                    color: theme.palette.text.primary,
                                    padding: "10px"
                                },
                            },
                        }}
                    />
                </LocalizationProvider>
            </FormControl>
            {typeof error === 'string' && error !== 'Required' && (
                <Box display={'flex'} flexDirection={'row'} gap={'20px'}>
                    <Typography variant="subtitle_500" fontSize={{ lg: '14px', md: '14px', sm: '12px', xs: '12px' }} color={theme.palette.error[500]}>{error}</Typography>
                </Box>
            )}
        </Box>
    )
}

